import React from "react";
import "./TermsConditions.css";
import banner from "../Images/bg_img.webp"; 
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const TermsConditions = () => {
  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <section className="terms-banner">
        <img src={banner} alt="Terms & Conditions" className="banner-image" />
        <div className="banner-overlay">
          <h1>Terms & Conditions</h1>
          <p>Guidelines & Policies of Sri Ashtothara Shatha (108) Chukkala Charitable Trust</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content">
        <div className="terms-container">
          <h2>TERMS & CONDITIONS</h2>
          <p>
            Thank you for accessing/shopping at <a href="https://sascct.org">https://sascct.org</a>. 
            This site is owned by Sri Ashtothara Shatha (108) Chukkala’s Charitable Trust 
            (hereinafter referred to as https://sascct.org). By accessing, shopping on this site, you indicate your 
            unconditional acceptance of these terms & conditions. We reserve this right, in our sole discretion, 
            to update or revise these terms & conditions. Continued use of the site following the posting of any 
            changes to the ‘terms & conditions’, constitutes your acceptance of those changes. At https://sascct.org, 
            we try our best to create a space where you can explore and shop for all your favorite things in a safe 
            and secure environment. All products and information displayed on https://sascct.org constitutes an 
            “invitation to offer”. https://sascct.org reserves the right to accept or reject your offer. Your order 
            for purchase constitutes your “offer” which shall be subject to the terms and conditions as listed below.
          </p>

          <h3>1. Eligibility to use our site</h3>
          <p>
            Use of the Site is available only to persons who can legally enter into contracts under applicable laws. 
            Persons who are “incompetent to contract”, within the meaning of the Indian Contract Act, 1872 including 
            un-discharged insolvents etc. are not eligible to use the Site. https://sascct.org reserves the right 
            to terminate your access to the Site if it discovers that you are under the age of 18 years or suffers from 
            any other disability, as recognized under Indian Contract Act, 1872.
          </p>

          <h3>2. Membership</h3>
          <p>
            Although it’s not essential to have an account to shop with https://sascct.org, you can shop as a guest. 
            As a member, you agree to provide true, accurate, current, and complete information about yourself as 
            prompted by the site’s registration form. Registration where prohibited under any law shall be void. 
            https://sascct.org reserves the right to revoke or terminate your registration for any reason at any time, 
            without notice.
          </p>

          <h3>3. Electronic Communications</h3>
          <p>
            When you use the site or send emails or other data, information or communicate to us, you agree and 
            understand that you are communicating with us electronically and give your consent to receive communications 
            electronically from us periodically, when required.
          </p>

          <h3>4. Reviews, Feedback, Submissions</h3>
          <p>
            All reviews, comments, feedback, postcards, suggestions, ideas, and other submissions disclosed, submitted 
            or offered to https://sascct.org directly or otherwise disclosed, submitted or offered in connection with your 
            use of this Site (collectively referred to as “Comments”) will remain https://sascct.org property. Such disclosure, 
            submission or offer of any comments shall constitute an assignment to https://sascct.org of all worldwide rights, 
            titles and interests in all copyrights and other intellectual properties in the comments, thus, it exclusively owns 
            all such rights, titles and interests and shall not be limited in any way in its use, commercial or otherwise. 
            https://sascct.org will be entitled to use, reproduce, disclose, modify, adapt, create derivative works from, 
            publish, display and distribute any comments you submit for any purpose whatsoever, without restriction and without 
            compensating you in any way. https://sascct.org is and shall be under no obligation (1) to maintain any Comments in 
            confidence; or (2) to pay you any compensation for any Comments; or (3) to respond to any Comments. You agree that any 
            comments submitted by you to the Site will not violate this policy or any right of any third party, including copyright, 
            trademark, privacy or other personal or proprietary right(s), and will not cause injury to any person or entity. You 
            further agree that no comments submitted by you to the site will be libellous or otherwise unlawful, threatening, abusive 
            or obscene material, or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings 
            or any form of “spam”.
          </p>
          <p>
            https://sascct.org does not regularly review posted comments, but does reserve the right (but not the obligation) to monitor 
            and edit or remove any comment submitted to the Site. You grant https://sascct.org the right to use the name that you submit 
            in connection with any of the posted comments. You agree not to use a false email address, impersonate any person or entity, 
            or otherwise mislead as to the origin of any Comments you submit. You are and shall remain solely responsible for the content 
            of any comments you make and you agree to indemnify https://sascct.org and its affiliates for all claims resulting from any 
            Comments you submit, we take no responsibility and assume no liability for any comments submitted by you or any third party.
          </p>

          <h3>5. Accuracy of Content/ Information of Products on the Web Site</h3>
          <p>
            While https://sascct.org strives to provide accurate product and pricing information, typographical errors may occur. 
            In the event that a product is listed at an incorrect price or with incorrect information due to an error in pricing or 
            product information, https://sascct.org shall have the right, at our sole discretion, to modify the price of the products, 
            or information of the products or to refuse or cancel any orders placed for that product, unless the product has already 
            been dispatched.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default TermsConditions;
